import React from "react";

const sections = [
  {
    title: "Central Government",
    links: [
      { name: "National Portal of India", url: "https://www.india.gov.in" },
      { name: "Prime Minister's Office", url: "https://www.pmindia.gov.in" },
      { name: "President of India", url: "https://presidentofindia.nic.in" },
      { name: "Ministry of Finance", url: "https://www.finmin.nic.in" },
      { name: "Ministry of Home Affairs", url: "https://www.mha.gov.in" },
    ],
  },
  {
    title: "State Governments",
    links: [
      { name: "Maharashtra Government", url: "https://www.maharashtra.gov.in" },
      { name: "Uttar Pradesh Government", url: "https://up.gov.in" },
      { name: "Tamil Nadu Government", url: "https://www.tn.gov.in" },
      { name: "Karnataka Government", url: "https://www.karnataka.gov.in" },
    ],
  },
  {
    title: "Judiciary",
    links: [
      { name: "Supreme Court of India", url: "https://www.sci.gov.in" },
      { name: "High Courts of India", url: "https://hcservices.ecourts.gov.in" },
      { name: "District Courts (eCourts)", url: "https://ecourts.gov.in" },
    ],
  },
  {
    title: "Parliament & Legislature",
    links: [
      { name: "Lok Sabha", url: "https://loksabha.nic.in" },
      { name: "Rajya Sabha", url: "https://rajyasabha.nic.in" },
      { name: "Legislative Assembly Portals", url: "https://legislativebodiesinindia.nic.in" },
    ],
  },
  {
    title: "Constitutional & Statutory Bodies",
    links: [
      { name: "Election Commission of India", url: "https://eci.gov.in" },
      { name: "UPSC", url: "https://www.upsc.gov.in" },
      { name: "CAG of India", url: "https://cag.gov.in" },
      { name: "NITI Aayog", url: "https://www.niti.gov.in" },
    ],
  },
  {
    title: "Law, Compliance & Public Services",
    links: [
      { name: "Income Tax Department", url: "https://www.incometax.gov.in" },
      { name: "GST Portal", url: "https://www.gst.gov.in" },
      { name: "MCA", url: "https://www.mca.gov.in" },
      { name: "DigiLocker", url: "https://www.digilocker.gov.in" },
    ],
  },
  {
    title: "Local Government Bodies",
    links: [
      { name: "Municipal Corporations", url: "https://www.india.gov.in/topics/housing-and-urban" },
      { name: "Panchayati Raj", url: "https://panchayat.gov.in" },
      { name: "Smart Cities Mission", url: "https://smartcities.gov.in" },
    ],
  },
];

export default function IndiaCivicIndex() {
  return (
    <div className="min-h-screen bg-black text-white px-4 py-6">
        <div className="bg-gradient-to-r from-orange-500 via-white to-green-600 px-4 py-4">
            <h1 className="text-xl md:text-2xl font-semibold text-center text-black">
                Think5Whys ICI – India Civic Index
            </h1>
            <p className="text-sm md:text-base font-medium text-center text-black/80">
                Official Government Portals
            </p>
        </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 mt-2 mb-2">
        {sections.map((section, index) => (
          <div
            key={index}
            className="border border-blue-400 rounded-md p-4"
          >
            <h2 className="text-lg lg:text-lg font-medium mb-1 text-blue-400">
              {section.title}
            </h2>

            <ul className="space-y-2">
              {section.links.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-sm text-white/80 hover:text-white underline underline-offset-4"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
        <div className="bg-gradient-to-r from-orange-500 via-white to-green-600 px-4 py-4">
            <p className="text-xs lg:text-sm font-semibold text-center text-black">
                (c) 2026 - Think5Whys Global DeepTech Solutions, Mumbai, Maharashtra, India
            </p>
            <p className="text-xs lg:text-sm text-center text-black/80">
                Disclaimer: This Index is aggregation of civic links and is presenetd for information purpose only.
            </p>
        </div>      
    </div>
  );
}
